import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './PageLike.css';
import { FaThumbsUp, FaPlus } from 'react-icons/fa';

const PageLike = ({ pageId, userId, onLikeChange }) => {
    const [likedByUser, setLikedByUser] = useState(false);
    const [likedData, setLikedData] = useState(null);
    const [likesCount, setLikesCount] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchLikeStatus = async () => {
            try {
                // Vérifier si l'utilisateur a déjà aimé la page
                const hasLiked = await sdk.models.PageLike.hasLiked({ page_id: pageId });
                if (hasLiked) {
                    setLikedData(hasLiked);
                    setLikedByUser(true);
                } else {
                    setLikedByUser(false);
                }
                
                // Récupérer le nombre total de likes
                const count = await sdk.models.PageLike.likeCount({ page_id: pageId });
                setLikesCount(count.count);
            } catch (error) {
                console.error('Erreur lors de la récupération des likes:', error);
            }
        };

        if (pageId) {
            fetchLikeStatus();
        }
    }, [pageId, userId]);

    const handleLike = async () => {
        if (loading) return;
        
        setLoading(true);
        const previousLikedState = likedByUser;
        
        // Optimistic UI update
        setLikedByUser(!previousLikedState);
        setLikesCount(prev => previousLikedState ? Math.max(0, prev - 1) : prev + 1);

        try {
            if (previousLikedState) {
                // Supprimer le like
                await sdk.models.PageLike.delete(likedData.id);
            } else {
                // Ajouter un like
                const newLike = await sdk.models.PageLike.create({ page_id: pageId });
                setLikedData(newLike);
            }
            
            // Notifier le composant parent du changement si onLikeChange est défini
            if (typeof onLikeChange === 'function') {
                onLikeChange(!previousLikedState);
            }
        } catch (error) {
            console.error('Erreur lors de la mise à jour du like:', error);
            // Revenir à l'état précédent en cas d'erreur
            setLikedByUser(previousLikedState);
            setLikesCount(prev => previousLikedState ? prev + 1 : Math.max(0, prev - 1));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="pqc-page-like-container">
            <div 
                className={`pqc-page-like-btn ${likedByUser ? 'pqc-page-like-btn-liked' : 'pqc-page-like-btn-not-liked'}`}
                onClick={handleLike}
                role="button"
                aria-pressed={likedByUser}
                disabled={loading}
            >
                <span className="pqc-page-like-icon">
                    {likedByUser ? <FaThumbsUp /> : <FaPlus />}
                </span>
                <span className="pqc-page-like-text">
                    {likedByUser ? 'J\'aime' : 'Suivre'}
                </span>
            </div>
            {likesCount > 0 && (
                <span className="pqc-page-like-count">
                    {likesCount} {likesCount === 1 ? 'abonné' : 'abonnés'}
                </span>
            )}
        </div>
    );
};

export { PageLike };